import React, { useEffect } from "react";
import ContactForm from "./ContactForm";
import { useI18n } from "../i18n";
import { useUi } from "../lib/ui";

export default function ContactModal() {
  const { t } = useI18n();
  const { contactOpen, closeContact } = useUi();

  useEffect(() => {
    if (!contactOpen) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") closeContact();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [contactOpen, closeContact]);

  if (!contactOpen) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-label={t("form.title")}>
      <button type="button" className="modal-backdrop" aria-label={t("common.close")} onClick={closeContact} />
      <div className="modal-card" data-testid="contact-modal">
        <div className="modal-head">
          <div>
            <span className="eyebrow">{t("form.subtitle")}</span>
            <h2 className="modal-title">{t("form.title")}</h2>
          </div>
          <button type="button" className="modal-close" onClick={closeContact} data-testid="modal-close">
            <span aria-hidden="true">×</span>
            <span className="sr-only">{t("common.close")}</span>
          </button>
        </div>
        <ContactForm compact onSubmitted={closeContact} />
      </div>
    </div>
  );
}
